import React, { useEffect } from 'react';
import { Form, Input, Row, Col } from 'antd';
import ValidatorHelper from '../helpers/ValidatorHelper';
// import { putDefaultAgentWage } from '../../actions/BusinessActions';
import StringHelper from '../helpers/StringHelper';
import { usePersistedStore } from '../../store/persisted-store';

export default function EditInsuranceDefaultWageForm({ onSubmit, branch }) {
    const [form] = Form.useForm();
    const { putDefaultAgentWage, users } = usePersistedStore()
    const loading = users.loading;

    useEffect(() => {
        if (branch) {
            form.setFieldsValue(branch[0]);
        }
        else
            form.resetFields();
    }, [form, branch]);

    const formLayout = {
        labelCol: {
            lg: 6,
            xs: 24
        },
        wrapperCol: {
            lg: 16,
            xs: 24
        }
    }
    const itemLayout = {
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
    }

    function onFinish(values) {
        const data = {
            InsuranceBranchId: branch[0].InsuranceBranchId,
            DefaultAgentWagePercent: parseFloat(StringHelper.getEnglishNum(values.DefaultAgentWagePercent)),
            DefaultAgentWagePrice: parseInt(values.DefaultAgentWagePrice)
        };
        putDefaultAgentWage({ data: data, reset: onSubmit });
        form.resetFields()
    };

    return (
        <Form
            form={form}
            name="user-form"
            className='business-form'
            {...formLayout}
            onFinish={onFinish}>
            <Row>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={[
                            ...ValidatorHelper.decimalNumber('درصد کارمزد')
                        ]}
                        name="DefaultAgentWagePercent"
                        label="درصد کارمزد">
                        <Input />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={[
                            ...ValidatorHelper.number('مبلغ کارمزد')
                        ]}
                        name="DefaultAgentWagePrice"
                        label="مبلغ کارمزد">
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <button type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ width: "100%" }}>
                <i className={`${loading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle mr-2 ml-3"`}></i>ثبت
            </button>
        </Form >
    )
}
